(function () {
  'use strict';

  if (window.MsPremiumProductCarousel) {
    window.MsPremiumProductCarousel.initAll(document);
    return;
  }

  function initCarousel(root) {
    if (!root || root.dataset.mspcReady === 'true') return;

    var scroller = root.querySelector('[data-mspc-scroller]');
    var prev = root.querySelector('[data-mspc-prev]');
    var next = root.querySelector('[data-mspc-next]');
    var cards = Array.prototype.slice.call(root.querySelectorAll('[data-premium-product-card]'));
    var resizeTimer = null;
    var readyTimer = null;
    var observer = null;
    var destroyed = false;

    if (!scroller || !cards.length) return;
    root.dataset.mspcReady = 'true';

    function cardStep() {
      if (!cards[0]) return scroller.clientWidth;
      var rect = cards[0].getBoundingClientRect();
      var styles = window.getComputedStyle(scroller.querySelector('.mspc__track') || scroller);
      var gap = parseFloat(styles.columnGap || styles.gap || '0') || 0;
      return rect.width + gap;
    }

    function updateControls() {
      if (destroyed) return;
      var maxScroll = Math.max(0, scroller.scrollWidth - scroller.clientWidth - 2);
      var left = scroller.scrollLeft;
      var hasOverflow = maxScroll > 4;

      root.classList.toggle('is-scrollable', hasOverflow);

      if (prev) prev.disabled = !hasOverflow || left <= 2;
      if (next) next.disabled = !hasOverflow || left >= maxScroll;
    }

    function cardsPerStep() {
      var step = cardStep();
      if (!step) return 1;
      var visible = scroller.clientWidth / step;
      return Math.max(1, Math.floor(visible));
    }

    function scrollByCards(direction) {
      var reducedMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      scroller.scrollBy({
        left: direction * cardStep() * cardsPerStep(),
        behavior: reducedMotion ? 'auto' : 'smooth'
      });
    }

    function scheduleUpdate() {
      if (destroyed) return;
      window.clearTimeout(resizeTimer);
      resizeTimer = window.setTimeout(updateControls, 80);
    }

    function onPrevClick() {
      scrollByCards(-1);
    }

    function onNextClick() {
      scrollByCards(1);
    }

    if (prev) prev.addEventListener('click', onPrevClick);
    if (next) next.addEventListener('click', onNextClick);

    scroller.addEventListener('scroll', scheduleUpdate, { passive: true });
    window.addEventListener('resize', scheduleUpdate, { passive: true });

    if ('ResizeObserver' in window) {
      observer = new ResizeObserver(scheduleUpdate);
      observer.observe(scroller);
      cards.forEach(function (card) {
        observer.observe(card);
      });
      root.mspcResizeObserver = observer;
    }

    if (document.fonts && document.fonts.ready) {
      document.fonts.ready.then(scheduleUpdate).catch(function () {});
    }

    root.mspcDestroy = function () {
      destroyed = true;
      window.clearTimeout(resizeTimer);
      window.clearTimeout(readyTimer);
      if (prev) prev.removeEventListener('click', onPrevClick);
      if (next) next.removeEventListener('click', onNextClick);
      scroller.removeEventListener('scroll', scheduleUpdate);
      window.removeEventListener('resize', scheduleUpdate);
      if (observer) observer.disconnect();
      delete root.mspcResizeObserver;
      delete root.mspcDestroy;
      delete root.dataset.mspcReady;
    };

    updateControls();
    readyTimer = window.setTimeout(updateControls, 250);
  }

  function initAll(root) {
    root = root || document;
    if (root.matches && root.matches('[data-ms-premium-product-carousel]')) initCarousel(root);
    root.querySelectorAll('[data-ms-premium-product-carousel]').forEach(initCarousel);
  }

  function destroyAll(root) {
    if (!root) return;
    if (root.mspcDestroy) root.mspcDestroy();
    root.querySelectorAll('[data-ms-premium-product-carousel]').forEach(function (carousel) {
      if (carousel.mspcDestroy) carousel.mspcDestroy();
    });
  }

  window.MsPremiumProductCarousel = { initAll: initAll };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      initAll(document);
    });
  } else {
    initAll(document);
  }

  document.addEventListener('shopify:section:load', function (event) {
    if (event && event.target) initAll(event.target);
  });

  document.addEventListener('shopify:section:unload', function (event) {
    if (event && event.target) destroyAll(event.target);
  });
})();
